module.exports = __webpack_public_path__ + "img/20200613_141445.b66f734b.jpg";